<template>
  <div class="Portfolio">
    <h3 class="heading-lined">{{ $t("share_page.porfolio") }}</h3>
    <div class="Portfolio__Chart">
      <ul class="Portfolio__Assets">
        <li
          class="Portfolio__Asset"
          v-for="(asset, index) in assets"
          :key="asset.id + asset.symbol + asset.exchId"
        >
          <span
            class="Portfolio__Asset-Color"
            :style="{ backgroundColor: getChartColor(index) }"
          ></span>
          {{ asset.name }}
          <ExchangeIcon
            v-if="asset.exchId > 0"
            :exchId="asset.exchId"
            :size="14"
            class="Portfolio__Asset--exchnageIcon"
          />
          <em>
            {{ formatNumber(asset.share) }}%
          </em>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Options from "@/options";
import NumbersMixin from "@/mixins/numbers";
import ExchangeIcon from "./ExchangeIcon.vue";

export default {
  name: "Portfolio",
  mixins: [NumbersMixin],
  components: {
    ExchangeIcon,
  },
  methods: {
    getChartColor(index) {
      return this.chartColors[index];
    },
  },
  computed: {
    chartColors() {
      return Options.chartColors.map((color, key) => {
        return this.assets[key] &&
          this.assets[key].color &&
          /^\#[A-F0-9]+$/i.test(this.assets[key].color)
          ? this.assets[key].color
          : color;
      });
    },
    assets() {
      return this.profitlossMode
        ? this.portfolioAssetsSortedByShare_pl
        : this.portfolioAssetsSortedByShare;
    },
    ...mapGetters({
      profitlossMode: "settings/profitlossMode",
      portfolioAssetsSortedByShare: "portfolio/portfolioAssetsSortedByShare",
      portfolioAssetsSortedByShare_pl:
        "profitloss/portfolioAssetsSortedByShare",
    }),
  },
};
</script>

<style lang="scss">
.Portfolio {
  margin-bottom: 50px;
}

.Portfolio__Assets {
  list-style: none;
  padding: 0;
  line-height: 2;
}

.Portfolio__Asset {
  display: inline-block;
  margin: 0 8px;
  em {
    font-style: normal;
    opacity: 0.5;
    font-weight: 300;
  }
}

.Portfolio__Asset-Color {
  display: inline-block;
  height: 16px;
  width: 16px;
  vertical-align: middle;
  overflow: hidden;
  border-radius: 50%;
  position: relative;
  top: -1px;
  margin-right: 5px;
}

.Portfolio__Asset--exchnageIcon {
  position: relative;
  top: -7px;
}
</style>
